import {CLAIM_PROCESSING_STATES,CLAIM_REFUND_STATES,claimTime,StatusCorrection} from './orderClaimProgress';

export default function ClaimCorrectionHistory({correction}:{correction?:StatusCorrection}) {
 if(!correction?.events.length)return null;
 return <details><summary>상태 수정 이력</summary><ol>{correction.events.map((event,index)=>{
   const states:ReadonlyArray<readonly [string,string]>=event.axis==='processing'?CLAIM_PROCESSING_STATES:CLAIM_REFUND_STATES;
   const label=(value:string|null)=>states.find(([key])=>key===value)?.[1]||value||'-';
   return <li key={index}>{claimTime(event.at)} · {event.axis==='processing'?'처리':'환불'} 상태 {label(event.before)} → {label(event.after)}{event.reason&&` · ${event.reason}`}</li>;
 })}</ol></details>;
}
